import { Link } from "react-router-dom";
import { Collapse } from "../../../ui";

import "./courseAbout.scss";
import { BiUser } from "react-icons/bi";

const image = require("../../../assets/aboutcourse.jpg");

const CourseAbout = () => {
  return (
    <div className="lg:px-32 md:px-20 px-6 pt-20 text-gray-300">
      <div className="flex gap-4 items-center lg:flex-row flex-col mb-12">
        <div className="flex-[.4] uppercase 2xl:text-[80px] xl:text-[56px] md:text-[40px] text-[28px] font-semibold lg:leading-38">
          Хичээлийн агуулга
        </div>
        <div className="flex-[.6] lg:leading-12 lg:text-start text-center">
          Байгаль дахь хууль өөрөө тэгш хэмийн тогтолцоог бий болгож гайхалтай
          давхцалаар нэгэн бүхэллэг шинжийг бүрдүүлж байдаг юм бол эдийн засгийн
          эрэлт, нийлүүлэлтийн хуулинд захирагдаж хөдөлдөг форекс зах зээлд тэгш
          хэм хэрхэн нөлөөлдөг талаар сүүлийн жилүүдэд нэлээдгүй судаллаа, үүний
          үр дүнд өөрийн гэсэн арга барилыг нээж 1$ - ийг 31,000$ болгож өөр
          гайхалтай түүхүүдийг ч хийж чадсан. Өөрийн судалгааны үр дүнд гаргаж
          авсан Ochiroo’s Theory арилжааны арга барилаа 23 бүлэг сэдэв бүхий
          хичээл болгож, анхан шатнаас ахисан шат хүртэл онлайн сургалтаар заах
          болно.
        </div>
      </div>
      <div className="flex gap-10 lg:flex-row flex-col">
        <div className="flex-1 relative">
          <div className="absolute z-5 left-[36%] right-0 bottom-0 top-[54%] bg-[#07122e] pl-7 pt-2 rounded-tl-[24px]">
            <div className="h-full bg-[#1f0189] rounded-4xl flex items-center justify-center md:text-[24px] text-2xl px-8 text-center">
              Market тэгш хэмээр хөдөлж, Цаг хугацаанд захирагддаг.
            </div>
          </div>
          <div className="flex gap-5">
            <img
              src={image}
              alt="cover"
              className="flex-1 w-full h-[260px] object-cover object-top overflow-hidden rounded-4xl"
            />
            <div className="flex-1 flex flex-col">
              <div className="flex-1 w-full bg-gradient-to-r from-[#301888] via-black to-[#473d82] border-[1px] border-[#301888] rounded-4xl flex items-center justify-center md:text-[24px] text-2xl">
                01. Хэмжээ гэж юу вэ?
              </div>
              <div className="flex-1"></div>
            </div>
          </div>
        </div>
        <div className="flex-1 flex flex-col lg:gap-0 gap-8">
          <div className="flex-1 h-[120px] overflow-hidden">
            <img
              className="w-full h-[200px] object-cover object-start rounded-4xl"
              alt=""
              src="https://cdn.prod.website-files.com/65de4c6f8dc17dc010f8ac55/65de4e8fa9dea47849bfe182_654d5b61a2e2c9c8d6cdeae7_5f57c46384cca65e79589acf_students1.jpeg"
            />
          </div>
          <div className="flex items-center gap-5 text-[18px] bg-[#1f0189] rounded-full flex items-center justify-center uppercase py-4 select-none cursor-pointer">
            <BiUser size={24} />
            <div>Бүртгүүлэх</div>
          </div>
        </div>
      </div>
      <div className="flex gap-10 mt-12 xl:px-40 lg:px-20 md:px10 md:flex-row flex-col">
        {/* <div className="bg-[#071949] rounded-4xl px-12 py-8 flex-1">
          <div className="uppercase font-semibold text-[18px] mb-6">
            Сургалтын төлбөрүүд
          </div>
          <div>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged.
          </div>
          <div className="flex gap-6 mt-6">
            <div
              className="select-none cursor-pointer border-[1px] border-gray-300 rounded-full px-8 py-2"
              onClick={() => {}}
            >
              Төлбөртэй
            </div>
            <div
              className="select-none cursor-pointer border-[1px] border-gray-300 rounded-full px-8 py-2"
              onClick={() => {}}
            >
              Төлбөргүй
            </div>
          </div>
        </div> */}
        {/* <div className="bg-[#071949] rounded-4xl px-12 py-8 flex-1">
          <div className="uppercase font-semibold text-[18px] mb-6">
            Шинэ мэдээ шуурхай авах
          </div>
          <div>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged.
          </div>
          <div className="mt-6 relative">
            <div className="bg-[#1a057c] absolute right-3 bottom-2 top-2 flex items-center px-12 rounded-full select-none cursor-pointer">
              Бүртгүүлэх
            </div>
            <input
              placeholder={"Имэйл хаяг оруулах"}
              className={`border rounded-full h-16 px-4 text-[16px] font-medium bg-black
                  focus:outline-none transition-colors duration-200 border-gray-300 text-gray-300`}
              style={{
                borderColor: "#000",
                transition: "border-color 0.2s, outline-width 0.2s",
              }}
              onFocus={(e) => {
                e.currentTarget.style.borderColor = "#000";
                e.currentTarget.style.outline = `solid 2px #000`;
                e.currentTarget.style.outlineOffset = "0px";
              }}
              onBlur={(e) => {
                e.currentTarget.style.borderColor = "#000";
                e.currentTarget.style.outline = "none";
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "#000";
              }}
              onMouseLeave={(e) => {
                if (document.activeElement !== e.currentTarget) {
                  e.currentTarget.style.borderColor = "#000";
                }
              }}
            />
          </div>
        </div> */}
      </div>
      {/* <div className="hCourseAbout__cover">
        <div className="hCourseAbout__cover-wall" />

        <figure className="hCourseAbout__cover-figure">
          <img src={image} alt="cover" />
        </figure>
      </div>

      <div className="hCourseAbout__content">
        <h1 className="hCourseAbout__content-title">
          Онлайн хичээлийн агуулга
        </h1>

        <div className="hCourseAbout__content-list">
          <Collapse
            title="01. Хэмжээ гэж юу вэ?"
            content="Market тэгш хэмээр хөдөлж, Цаг хугацаанд захирагддаг."
            bgColor="#ededed"
          />
          <Collapse
            title="02. Лааны цаг хугацаа гэж юу вэ?"
            content="Market тэгш хэмээр хөдөлж, Цаг хугацаанд захирагддаг."
            bgColor="#ededed"
          />
          <Collapse
            title="03. Цаг, хэмжээтэй уяалдах"
            content="Market тэгш хэмээр хөдөлж, Цаг хугацаанд захирагддаг."
            bgColor="#ededed"
          />
        </div>

        <div className="hCourseAbout__content-about">
          <h3 className="hCourseAbout__content-about-title">Онлайн Сургалт</h3>

          <p className="hCourseAbout__content-about-text">
            Байгаль дахь хууль өөрөө тэгш хэмийн тогтолцоог бий болгож гайхалтай
            давхцалаар нэгэн бүхэллэг шинжийг бүрдүүлж байдаг юм бол эдийн
            засгийн эрэлт, нийлүүлэлтийн хуулинд захирагдаж хөдөлдөг форекс зах
            зээлд тэгш хэм хэрхэн нөлөөлдөг талаар сүүлийн жилүүдэд нэлээдгүй
            судаллаа, үүний үр дүнд өөрийн гэсэн арга барилыг нээж 1$ - ийг
            31,000$ болгож өөр гайхалтай түүхүүдийг ч хийж чадсан. Өөрийн
            судалгааны үр дүнд гаргаж авсан Ochiroo’s Theory арилжааны арга
            барилаа 23 бүлэг сэдэв бүхий хичээл болгож, анхан шатнаас ахисан шат
            хүртэл онлайн сургалтаар заах болно.
          </p>

          <Link className="hCourseAbout__content-about-signup" to="/signup">
            Бүртгүүлэх
          </Link>
        </div>
      </div> */}
    </div>
  );
};

export default CourseAbout;
